module.exports = __webpack_public_path__ + "static/media/icon-9.5af2b601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-9.png
// module id = 1033
// module chunks = 0